// HAZIRLIK · motion leaf — timeline scrub reveal

import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { usePrefersReducedMotion } from "@/lib/animation/prefers-reduced-motion";
import { DUR } from "@/features/landing/motion/tokens";

export function useHazirlikMotion(scope: React.RefObject<HTMLElement | null>) {
  const reduced = usePrefersReducedMotion();

  useGSAP(
    () => {
      const title = scope.current?.querySelector<HTMLElement>(".hazirlik__title");
      const body = scope.current?.querySelector<HTMLElement>(".hazirlik__body");
      const steps = scope.current?.querySelectorAll<HTMLElement>(".hazirlik__step");

      if (reduced) {
        gsap.set([title, body, ...(steps ?? [])], { clearProps: "all" });
        return;
      }

      // Title + body reveal
      if (title) {
        gsap.fromTo(title, { autoAlpha: 0, y: 32 }, {
          autoAlpha: 1, y: 0, duration: DUR.slow, ease: "power3.out",
          scrollTrigger: { trigger: title, start: "top 80%", toggleActions: "play none none reset" },
        });
      }
      if (body) {
        gsap.fromTo(body, { autoAlpha: 0, y: 16 }, {
          autoAlpha: 1, y: 0, duration: DUR.normal, ease: "power2.out",
          scrollTrigger: { trigger: body, start: "top 85%", toggleActions: "play none none reset" },
        });
      }

      // Steps — scroll-scrubbed cascade
      if (steps && steps.length) {
        steps.forEach((step, i) => {
          gsap.fromTo(step, { autoAlpha: 0, x: 30 }, {
            autoAlpha: 1, x: 0, duration: DUR.normal, ease: "power2.out",
            delay: i * 0.05,
            scrollTrigger: { trigger: step, start: "top 88%", toggleActions: "play none none reset" },
          });
        });
      }
    },
    { scope, dependencies: [reduced] }
  );
}